import type { LLMJobProgress } from '../types';

interface JobProgressBarProps {
  progress: LLMJobProgress;
}

export default function JobProgressBar({ progress }: JobProgressBarProps) {
  const statusColors = {
    pending: 'bg-slate-400',
    running: 'bg-ocean-500',
    completed: 'bg-green-500',
    failed: 'bg-red-500',
  };
  
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className="text-slate-600">{progress.currentStep}</span>
        <span className="text-slate-500">{progress.progress}%</span>
      </div>
      
      <div className="h-2 bg-slate-200 rounded-full overflow-hidden">
        <div
          className={`h-full transition-all duration-300 ${statusColors[progress.status]}`}
          style={{ width: `${progress.progress}%` }}
        />
      </div>
      
      {progress.error && (
        <p className="text-sm text-red-600">{progress.error}</p>
      )}
      
      {progress.status === 'completed' && progress.outputPreview && (
        <p className="text-sm text-green-600 truncate">
          ✓ {progress.outputPreview}
        </p>
      )}
    </div>
  );
}


